import React, { useState, useEffect } from 'react';
import { Stack, Row, Col, Dropdown } from 'react-bootstrap';
import { useDeleteSavedJobAlertMutation, useSavedJobAlertListQuery } from 'services';
import PaginationBox from 'components/PaginationBox';
import { dataLimits } from 'constants';
import toast from 'react-hot-toast';
import Loader from 'components/Common/Loader';
import useCommonStore, { setModalConfig } from 'store/common';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const JobAlertList: React.FC = () => {
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState(1);
	const [orderBy, setOrderBy] = useState('createdAt');
	const [order, setOrder] = useState('DESC');

	const { hideCommonModal }: any = useCommonStore((state) => state);

	const { mutateAsync: DeleteSavedJobAlert, isPending } = useDeleteSavedJobAlertMutation();
	const queryOptions: string = `limit=${dataLimits?.appliedJobs}&page=${currentPage}&orderBy=${orderBy}&order=${order}`;
	const { data: { docs: jobs = [], meta = {} } = [], refetch } =
		useSavedJobAlertListQuery(queryOptions);
	const { limit = 10, totalDocs } = meta;

	useEffect(() => {
		refetch();
	}, [currentPage]);

	const onHandleClickOnDelete = (id: number) => {
		setModalConfig({
			visible: true,
			id: id,
			type: 'confirmModal',
			onClick: () => onHandleYes(id),
			data: {
				title: translate('Modal.wantToDelete', { title: `${translate('Modal.savedJobAlert')}` }),
			},
			props: {
				dialogClassName: 'confirm-modal',
			},
		});
	};

	const onHandleYes = (id: number) => {
		DeleteSavedJobAlert(id)
			.then((res: any) => {
				if (res?.success) {
					toast.success(res?.message);
					refetch();
				} else {
					toast.error(res?.message);
				}
			})
			.finally(() => {
				hideCommonModal();
			});
	};

	return (
		<div className="right-area flex-1 d-flex flex-column">
			<div className="white-box bg-white">
				<Stack className="gap-3 gap-md-4">
					<div className="jobs-filter d-flex align-items-center justify-content-between">
						<h5 className="fw-semibold mb-0">{translate('JobDetailBox.savedJobAlerts')}</h5>
					</div>

					<div className="job-alert-list">
						<Row>
							{jobs?.length > 0 ? (
								jobs.map((job: any, index: number) => (
									<Col key={index} xxl={4} md={6}>
										<Stack className="job-alert-box">
											<div className="d-flex align-items-center justify-content-between">
												<h5 className="fw-bold mb-0">{job?.title}</h5>
												<div className="edit-action">
													<Dropdown>
														<Dropdown.Toggle
															variant="success"
															id="dropdown-basic"
															className="p-0 border-0 rounded-circle"
														>
															<i className="ri-more-2-fill"></i>
														</Dropdown.Toggle>

														<Dropdown.Menu>
															<Dropdown.Item onClick={() => onHandleClickOnDelete(job?.id)}>
																{isPending ? (
																	<Loader />
																) : (
																	<>
																		<i className="ri-delete-bin-7-line"></i>{' '}
																		{translate('Common.delete')}
																	</>
																)}
															</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</div>
											<p className="mb-0">{job?.location}</p>
											<p className="mb-0">{job?.industryName}</p>
										</Stack>
									</Col>
								))
							) : (
								<Col>
									<Stack className="posted-job-box">
										<p className="mb-0">{translate('Common.noJobsFound')} </p>
									</Stack>
								</Col>
							)}
						</Row>
					</div>
				</Stack>

				{totalDocs > limit && (
					<PaginationBox
						totalData={totalDocs}
						limit={limit}
						page={currentPage}
						setCurrentPage={setCurrentPage}
					/>
				)}
			</div>
		</div>
	);
};

export default JobAlertList;
